import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '@app/services/auth/auth.service';

// Inject root
// Exports class AuthGuard
// Implements CanActivate
@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate {

    /**
     * @description Constructor accepts auth,  route
     * create a instance of auth.guard
     * @param auth
     * @param router
     */
    constructor(private readonly auth: AuthService,
        private readonly router: Router) {
    }

    /**
     * Method to navigate the user if authenticated else naviagte to login process
     * @description can active route
     */
    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        const url: string = state.url;
        
        if (this.auth.isLoggedIn()) {
            return true;
        }

        // Store user entered URL to session storage
        sessionStorage.setItem('usrEnteredURL', url);
       
        this.router.navigateByUrl('/');

        return false;
    }


}
